import { useContext } from "react";

import { useOrganisationContext } from "@/contexts/organisations/OrganisationContext";
import { ViewerContext } from "@/tpo/Viewer";
import { useQuery } from "@apollo/client";

import { DatapointGraphUi } from "./cot/DatapointGraph";

export default function DatapointGraph({
  query,
  skip,
  userDatapoint: {
    datapoint: { id: datapointId },
    chartConfiguration
  }
}) {
  const viewerContext = useContext(ViewerContext);
  const orgContext = useOrganisationContext();
  const organisationId = orgContext?.organisationId;

  const { data } = useQuery(query, {
    variables: {
      datapointId,
      cot: true,
      userId: viewerContext?.userId,
      organisationId
    },
    fetchPolicy: "cache-first",
    nextFetchPolicy: "cache-first",
    skip
  });

  return (
    <DatapointGraphUi
      chartConfiguration={chartConfiguration}
      userDatapoints={data?.userDatapoints || null}
    />
  );
}
